export var TagsSize;
(function (TagsSize) {
    TagsSize["small"] = "small";
    TagsSize["medium"] = "medium";
    TagsSize["large"] = "large";
})(TagsSize || (TagsSize = {}));
export var TagsAlignment;
(function (TagsAlignment) {
    TagsAlignment["center"] = "center";
    TagsAlignment["left"] = "left";
    TagsAlignment["right"] = "right";
})(TagsAlignment || (TagsAlignment = {}));
export var TagsSkin;
(function (TagsSkin) {
    TagsSkin["light"] = "light";
    TagsSkin["solid"] = "solid";
})(TagsSkin || (TagsSkin = {}));
//# sourceMappingURL=types.js.map